// SUB MENU
if ($('.sub-menu').length) {
    let subMenu = $('.sub-menu')
    let subMenuUL = subMenu.find('ul')
    let subMenuIMG = subMenu.find('.image-field')
    let hoverTimeOut
    subMenuUL.find('li').hover(
        function () {
            let image = $(this).attr('data-image');

            subMenuIMG.find('.image').addClass('active');

            clearTimeout(hoverTimeOut);
            hoverTimeOut = setTimeout(() => {
                subMenuIMG.find('img').attr('src', image);

                let loadedImage = document.createElement('img');
                loadedImage.src = image

                loadedImage.onload = function () { subMenuIMG.find('.image').removeClass('active'); }
            }, 450);
        },
        function () { },
    )
    $.each(subMenuUL.find('li'), function () {
    })
}

// EDITOR CENTER FIX FOR UL
if ($('.editor').length) {
    $.each($('.editor'), function () {
        if ($(this).find('ul').length) {
            $(this).removeClass('text-center')
        }
    })
}

// CERTIFICATE - TOP FIELD - LEFT FIELD
if ($('.certificate-top-field').length) {
    // EĞER HTML dir="rtl" İSE
    if ($('html').attr('dir') == 'rtl') {
        let mainField = $('.certificate-top-field')
        let mainWrapper = mainField.find('.wrapper')
        let contentField = $('.certificate-top-field .wrapper .left-field .image')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2
        contentField.css({
            'right': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px)'
        })

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2

            contentField.css({
                'right': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
        })
    } else {
        let mainField = $('.certificate-top-field')
        let mainWrapper = mainField.find('.wrapper')
        let contentField = $('.certificate-top-field .wrapper .left-field .image')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2
        contentField.css({
            'left': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px)'
        })

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2

            contentField.css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
        })
    }
}

// ABOUT - TEXT FIELD
if ($('.about-text-field').length) {
    // EĞER HTML dir="rtl" İSE
    if ($('html').attr('dir') == 'rtl') {
        let mainField = $('.about-text-field')
        let mainWrapper = mainField.find('.wrapper')
        let contentFieldOdd = $('.about-text-field .wrapper:nth-child(odd) .image-field .image')
        let contentFieldEven = $('.about-text-field .wrapper:nth-child(even) .image-field .image')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2

        $.each(mainWrapper, function () {
            $(this).find('.image-field').css({
                'height': $(this).find('.text-field .inner-text').height() + 150
            })
        })
        contentFieldOdd.css({
            'right': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px)'
        })
        contentFieldEven.css({
            'left': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px)'
        })

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2

            contentFieldOdd.css({
                'right': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
            contentFieldEven.css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
        })
    } else {
        let mainField = $('.about-text-field')
        let mainWrapper = mainField.find('.wrapper')
        let contentFieldOdd = $('.about-text-field .wrapper:nth-child(odd) .image-field .image')
        let contentFieldEven = $('.about-text-field .wrapper:nth-child(even) .image-field .image')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2

        $.each(mainWrapper, function () {
            $(this).find('.image-field').css({
                'height': $(this).find('.text-field .inner-text').height() + 150
            })
        })
        contentFieldOdd.css({
            'left': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px)'
        })
        contentFieldEven.css({
            'right': -remainWidth,
            'width': 'calc(100% + ' + remainWidth + 'px)'
        })

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2

            contentFieldOdd.css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
            contentFieldEven.css({
                'right': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
        })
    }
}

// ABOUT - BOX FIELD
if ($('.about-box-field').length) {

    if ($('html').attr('dir') != 'rtl') {
        let rowCount, boxWidth, mainCount, countRow, countHeight, boxPB
        if (windowWidth < 768) {
            rowCount = 1
            boxWidth = '100%'
            mainCount = $('.about-box-field .about-box').length;
            countRow = Math.ceil(mainCount / rowCount);
            countHeight = 100 / countRow;
            boxPB = "35px";
        }
        else if (windowWidth <= 1280) {
            rowCount = 2
            boxWidth = '50%'
            mainCount = $('.about-box-field .about-box').length;
            countRow = Math.ceil(mainCount / rowCount);
            countHeight = 100 / countRow;
            boxPB = "35px";
        }
        else if (windowWidth > 1280) {
            rowCount = 3
            boxWidth = '33%'
            mainCount = $('.about-box-field .about-box').length;
            countRow = Math.ceil(mainCount / rowCount);
            countHeight = 100 / countRow;
            boxPB = "35px";
        }
        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            if (windowResize < 768) {
                rowCount = 1
                boxWidth = '100%'
                mainCount = $('.about-box-field .about-box').length;
                countRow = Math.ceil(mainCount / rowCount);
                countHeight = 100 / countRow;
                boxPB = "35px";
            }
            else if (windowResize <= 1280) {
                rowCount = 2
                boxWidth = '50%'
                mainCount = $('.about-box-field .about-box').length;
                countRow = Math.ceil(mainCount / rowCount);
                countHeight = 100 / countRow;
                boxPB = "35px";
            }
            else if (windowResize > 1280) {
                rowCount = 3
                boxWidth = '33%'
                mainCount = $('.about-box-field .about-box').length;
                countRow = Math.ceil(mainCount / rowCount);
                countHeight = 100 / countRow;
                boxPB = "35px";
            }
            $('.about-box-field .background-hover').css({ 'top': 0 });
        });
        $('.about-box-field .background-hover').css({ 'top': 0 });
        $('.about-box-field .about-box').hover(
            function () {
                $('.about-box-field .background-hover').css({ 'height': $(this).height() + 'px' });
                let top = $(this).offset().top - $('.about-box-field .wrapper').offset().top
                let left = $(this).offset().left - $('.about-box-field .wrapper').offset().left
                $(this).closest('.wrapper').find('.background-hover').css({ 'left': left, 'top': top, 'opacity': '1', 'transform': 'scale(1)', 'width': $(this).width() })
            },
            function () {
                $(this).closest('.wrapper').find('.background-hover').css({ 'opacity': '0', 'transform': 'scale(0)' })
            }
        );
    }
}

// SAMPLE FORM
if ($('.sample-form-field').length) {

    // EĞER HTML dir="rtl" İSE
    if ($('html').attr('dir') == 'rtl') {
        let mainField = $('.sample-form-field')
        let mainWrapper = mainField.find('.wrapper')
        let contentField = mainWrapper.find('.image')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2

        if (windowWidth > 1024) {
            contentField.css({
                'right': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
        } else {
            contentField.css({
                'right': 0,
                'width': '100%'
            })
        }

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2
            if (windowResize > 1024) {
                contentField.css({
                    'right': -remainWidth,
                    'width': 'calc(100% + ' + remainWidth + 'px)'
                })
            } else {
                contentField.css({
                    'right': 0,
                    'width': '100%'
                })
            }
        })
    } else {
        let mainWrapper = mainField.find('.wrapper')
        let mainField = $('.sample-form-field')
        let contentField = mainWrapper.find('.image')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2

        if (windowWidth > 1024) {
            contentField.css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
        } else {
            contentField.css({
                'left': 0,
                'width': '100%'
            })
        }

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2
            if (windowResize > 1024) {
                contentField.css({
                    'left': -remainWidth,
                    'width': 'calc(100% + ' + remainWidth + 'px)'
                })
            } else {
                contentField.css({
                    'left': 0,
                    'width': '100%'
                })
            }
        })
    }

}

// BLOG
if ($('.blog-field').length) {
    let blogField = $('.blog-field')
    let blogTextField = $('.blog-field .wrapper .blog-box-content .main-text-field')
    let blogBoxOdd = $('.blog-field .wrapper .blog-box-content .blog-box:nth-child(odd)')
    let blogBox = $('.blog-box')
    // EĞER HTML dir="rtl" İSE
    if ($('html').attr('dir') == 'rtl') {
        if (windowWidth > 768) {
            blogTextField.css({
                'width': blogBox.width(),
                'left': 0,
            })
            blogBoxOdd.css({
                'transform': 'translateY(calc(35px + ' + blogTextField.height() + 'px))'
            })
            blogField.css({
                'margin-bottom': 'calc(35px + ' + blogTextField.height() + 'px + 35px)'
            })
        }
    } else {
        if (windowWidth > 768) {
            blogTextField.css({
                'width': blogBox.width(),
                'right': 0,
            })
            blogBoxOdd.css({
                'transform': 'translateY(calc(35px + ' + blogTextField.height() + 'px))'
            })
            blogField.css({
                'margin-bottom': 'calc(35px + ' + blogTextField.height() + 'px + 35px)'
            })
        }
    }
}

// PRODUCT DETAIL - IMAGE FIELD
if ($('.product-detail-field').length) {
    // EĞER HTML dir="rtl" İSE
    if ($('html').attr('dir') == 'rtl') {
        let productField = $('.product-detail-field')
        let productWrapper = productField.find('.wrapper')
        let productContent = $('.product-detail-field .wrapper > .image-field')
        let productRemainWidth = (productField.width() - productWrapper.width()) / 2
        if (windowWidth > 1024) {
            productContent.css({
                'right': -productRemainWidth,
                'width': 'calc(100% + ' + productRemainWidth + 'px)'
            })
        } else {
            productContent.css({
                'right': 0,
                'width': '100%'
            })
        }

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let productRemainWidth = (productField.width() - productWrapper.width()) / 2
            if (windowResize > 1024) {
                productContent.css({
                    'right': -productRemainWidth,
                    'width': 'calc(100% + ' + productRemainWidth + 'px)'
                })
            } else {
                productContent.css({
                    'right': 0,
                    'width': '100%'
                })
            }
        })
    } else {
        let mainField = $('.product-detail-field')
        let mainWrapper = mainField.find('.wrapper')
        let contentField = $('.product-detail-field .wrapper > .image-field')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2
        if (windowWidth > 1024) {
            contentField.css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
        } else {
            contentField.css({
                'left': 0,
                'width': '100%'
            })
        }

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2
            if (windowResize > 1024) {
                contentField.css({
                    'left': -remainWidth,
                    'width': 'calc(100% + ' + remainWidth + 'px)'
                })
            } else {
                contentField.css({
                    'left': 0,
                    'width': '100%'
                })
            }
        })
    }
}

// PRODUCT DETAIL - TAB FIELD
if ($('.product-detail-field').length) {
    let productTab = $('.product-detail-field .wrapper .content-field .tab-field')
    let productTabContent = $('.product-detail-field .wrapper .content-field .tab-content-field')
    let productTabID, productTabContentID
    productTabContent.css({
        'height': productTabContent.find('.tab-content.active').height()
    })
    setTimeout(() => {
        productTabContent.css({
            'height': productTabContent.find('.tab-content.active').height()
        })
    }, 450);

    productTab.find('ul li').click(function () {
        productTab.find('ul li').removeClass('active')
        $(this).addClass('active')
        productTabID = $(this).data('id')
        productTabContent.find('.tab-content').removeClass('active')

        $.each(productTabContent.find('.tab-content'), function () {
            productTabContentID = $(this).data('id')
            if (productTabContentID == productTabID) {
                $(this).addClass('active')
                productTabContent.css({
                    'height': $(this).height()
                })
            }
        })
    })
}

// PRODUCT DETAIL - SWITCH
if ($('.product-detail-field').length) {
    let switchSelector = $('.product-detail-field .switch-field')
    let switchBox = $('.product-detail-field .switch-field .switch-box')
    let switchText = $('.product-detail-field .switch-field .switchable-text')
    let leftContent = $('.product-detail-field .left-content')
    let switchID, leftContentID, switchTextID
    switchSelector.click(function () {
        switchID = $(this).attr('data-id')
        switchBox.removeClass('left right')
        $.each(switchText.find('.switch'), function () {
            $(this).removeClass('active')
            switchTextID = $(this).attr('data-id')
            if (switchTextID == switchID) {
                $(this).addClass('active')
            }
        })
        if (switchID == 1) {
            switchSelector.attr('data-id', 2)
            switchBox.addClass('left')
        }
        if (switchID == 2) {
            switchSelector.attr('data-id', 1)
            switchBox.addClass('right')
        }
        $.each(leftContent, function () {
            $(this).removeClass('active')
            leftContentID = $(this).attr('data-id')

            if (leftContentID == switchID) {
                $(this).addClass('active')
            }
        })
    })
}

// HOMEPAGE - ABOUT
if ($('.homepage-about-field').length) {
    let ha = $('.homepage-about-field')
    let haBGIMG = $('.homepage-about-field .background-image .image')
    if (windowWidth > 768) {
        ha.css({
            'height': haBGIMG.closest('.homepage-about-field').find('.wrapper').height() + 120
        })
    } else {
        ha.css({
            'height': haBGIMG.closest('.homepage-about-field').find('.wrapper').height()
        })
    }
}

// HOMEPAGE - MAP
if ($('.homepage-earth-field').length) {
    let earthLI = $('.homepage-earth-field .wrapper .left-field ul li')
    let earthDot = $('.homepage-earth-field .wrapper .right-field .map-field .dots .dot')
    let earthLIID, earthDotID
    earthLI.hover(
        function () {
            earthLIID = $(this).attr('data-id')
            $.each(earthDot, function () {
                $(this).removeClass('active')
                earthDotID = $(this).attr('data-id')
                if (earthLIID == earthDotID) {
                    $(this).addClass('active')
                }
            })
        },
        function () {
            $.each(earthDot, function () {
                $(this).removeClass('active')
            })
        }
    )
    earthDot.hover(
        function () {
            earthDotID = $(this).attr('data-id')
            $.each(earthLI, function () {
                $(this).removeClass('active')
                earthLIID = $(this).attr('data-id')
                if (earthDotID == earthLIID) {
                    $(this).addClass('active')
                }
            })
        },
        function () {
            $.each(earthLI, function () {
                $(this).removeClass('active')
            })
        }
    )
}

// HOMEPAGE - PRODUCT
if ($('.homepage-product-field').length) {

    let mainField = $('.homepage-product-field')
    let mainWrapper = mainField.find('.wrapper')
    let contentField = $('.homepage-product-field .wrapper .carousel-field .image-content')
    let remainWidth = (mainField.width() - mainWrapper.width()) / 2
    if (windowWidth > 1024) {
        contentField.css({
            'left': -remainWidth + 30,
            'width': 'calc(100% + ' + remainWidth + 'px)'
        })
    }

    $(window).on('resize', function () {
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2

        if (remainWidth > 1024) {
            contentField.css({
                'left': -remainWidth,
                'width': 'calc(100% + ' + remainWidth + 'px)'
            })
        }
    })
    // EĞER HTML dir="rtl" İSE
    if ($('html').attr('dir') == 'rtl') {
        let productField = $('.homepage-product-field')
        let productWrapper = productField.find('.wrapper')
        let productContent = $('.homepage-product-field .wrapper .carousel-field .image-content')
        let productRemainWidth = (productField.width() - productWrapper.width()) / 2
        if (windowWidth > 1024) {
            productContent.css({
                'right': -productRemainWidth,
                'width': 'calc(100% + ' + productRemainWidth + 'px)'
            })
        }

        $(window).on('resize', function () {
            let productRemainWidth = (productField.width() - productWrapper.width()) / 2

            if (productRemainWidth > 1024) {
                productContent.css({
                    'right': -productRemainWidth,
                    'width': 'calc(100% + ' + productRemainWidth + 'px)'
                })
            }
        })
    }
}

// CONTACT
if ($('.contact-top-field').length) {
    // EĞER HTML dir="rtl" İSE
    if ($('html').attr('dir') == 'rtl') {
        let mainField = $('.contact-top-field')
        let mainWrapper = mainField.find('.wrapper')
        let generalContent = $('.contact-top-field .container .wrapper .contact-information-field .general-content')
        let imageField = $('.contact-top-field .container .wrapper .contact-information-field .image-field')
        let contentField = $('.contact-top-field .container .wrapper .contact-information-field .main-contact-field')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2
        let generalWidth = generalContent.attr('data-image-width')
        if (windowWidth > 1680) {
            imageField.css({
                'right': -remainWidth,
                'width': remainWidth + parseInt(generalWidth)
            })
            contentField.css({
                'width': 'calc(100% - ' + generalWidth + 'px)',
                'margin-right': 'auto',
                'margin-left': '0',
            })
        }

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2

            if (windowResize > 1680) {
                imageField.css({
                    'right': -remainWidth,
                    'width': remainWidth + parseInt(generalWidth)
                })
                contentField.css({
                    'width': 'calc(100% - ' + generalWidth + 'px)',
                    'margin-right': 'auto',
                    'margin-left': '0',
                })
            }
        })
    } else {
        let mainField = $('.contact-top-field')
        let mainWrapper = mainField.find('.wrapper')
        let generalContent = $('.contact-top-field .container .wrapper .contact-information-field .general-content')
        let imageField = $('.contact-top-field .container .wrapper .contact-information-field .image-field')
        let contentField = $('.contact-top-field .container .wrapper .contact-information-field .main-contact-field')
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2
        let generalWidth = generalContent.attr('data-image-width')
        if (windowWidth > 1680) {
            imageField.css({
                'left': -remainWidth,
                'width': remainWidth + parseInt(generalWidth)
            })
            contentField.css({
                'width': 'calc(100% - ' + generalWidth + 'px)',
                'margin-left': 'auto',
                'margin-right': '0',
            })
        }

        $(window).on('resize', function () {
            let windowResize = window.innerWidth
            let remainWidth = (mainField.width() - mainWrapper.width()) / 2

            if (windowResize > 1680) {
                imageField.css({
                    'left': -remainWidth,
                    'width': remainWidth + parseInt(generalWidth)
                })
                contentField.css({
                    'width': 'calc(100% - ' + generalWidth + 'px)',
                    'margin-left': 'auto',
                    'margin-right': '0',
                })
            }
        })
    }
}

// HOMEPAGE ORDER FIELD

if ($('.homepage-order-field').length) {
    let mainField = $('.homepage-order-field')
    let mainWrapper = mainField.find('.wrapper')
    let contentField = $('.homepage-order-field .wrapper .carousel-field .carousel-pagination-field .content')
    let remainWidth = (mainField.width() - mainWrapper.width()) / 2
    contentField.css({
        'right': -remainWidth,
    })

    $(window).on('resize', function () {
        let windowResize = window.innerWidth
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2

        contentField.css({
            'right': -remainWidth,
        })
    })
}

// PLUS MINUS
if ($('.plus-minus').length) {
    let plus = $('.plus-minus .plus')
    let minus = $('.plus-minus .minus')
    plus.click(function () {
        let input = $(this).closest('.custom-number').find('input')
        let inputVal = input.val()
        let max = parseInt(input.attr('max'))

        if (inputVal < max) {
            inputVal++;
            input.val(inputVal)
        }
    })
    minus.click(function () {
        let input = $(this).closest('.custom-number').find('input')
        let inputVal = input.val();
        let min = parseInt(input.attr('min'))

        if (inputVal > min) {
            inputVal--;
            input.val(inputVal);
        }
    })
}

// PRODUCT STEP
if ($('.product-step').length) {
    let psProductField = $('.product-step .product-field')
    let psStepField = $('.product-step .step-field')
    let psMainContent = $('.product-step .main-content')
    if (windowWidth > 1440) {
        psMainContent.css({
            'height': $(window).height() - psProductField.innerHeight() - psStepField.innerHeight() - 120
        })
    } else if (windowWidth >= 1024 && windowWidth <= 1440 && window.innerHeight > 600) {
        psMainContent.css({
            'height': $(window).height() - psProductField.innerHeight() - psStepField.innerHeight() - 150
        })
    } else {
        if (window.innerHeight > 600) {
            psMainContent.css({
                'height': $(window).height() - psProductField.innerHeight() - psStepField.innerHeight() - 80
            })
        }
    }

    let prevStep = $('.step-back')
    let nextStep = $('.next-step')
    let stepSelector = $('.product-step .wrapper .step-field .content .step')
    let nextID, psMainID, stepID
    psMainContent.height(psMainContent.find('.content.active').find('.form-field').height())
    nextStep.click(function () {
        nextID = $(this).data('id')
        $.each(psMainContent.find('.content'), function () {
            $(this).removeClass('active')
            psMainID = $(this).attr('data-id')
            if (nextID == psMainID) {
                $(this).addClass('active')
                if (windowWidth > 1440) {
                    psMainContent.height($(window).height() - psProductField.innerHeight() - psStepField.innerHeight() - 100)
                } else if (windowWidth > 768) {
                    psMainContent.height($(window).height() - psProductField.innerHeight() - psStepField.innerHeight() - 150)
                } else {
                    psMainContent.height($(window).height() - psProductField.innerHeight() - psStepField.innerHeight() - 100)
                }
            }
        })
        $.each(stepSelector.find('li'), function () {
            $(this).removeClass('active')
            stepID = $(this).attr('data-id')
            if (nextID == stepID) {
                $(this).addClass('active')
            }
            if (stepID == 1) {
                prevStep.addClass('active')
            }
        })
    })

    // ÖNCEKİ ADIM
    prevStep.click(function () {
        prevStep.removeClass('active')
        stepSelector.find('li').removeClass('active')
        stepID = 1
        nextID = 1
        psMainID = 1
        stepSelector.find('li').removeClass('active')
        stepSelector.find('li:nth-child(1)').addClass('active')
        psMainContent.find('.content').removeClass('active')
        psMainContent.find('.content:nth-child(1)').addClass('active')

    })

    let productStepClose = $('.product-step .close')
    let bgOverlay = $('.bg-overlay.overlay-black')
    let body = $('body')
    productStepClose.click(function () {
        $('.product-step').removeClass('active')
        bgOverlay.removeClass('active')
        body.removeClass('ohide')
        $($('header').addClass('hide'))
    })

    let productStepOpen = $('.open-popup')
    productStepOpen.click(function () {
        $('.product-step').addClass('active')
        bgOverlay.addClass('active')
        body.addClass('ohide')
        $($('header').addClass('hide'))
    })

    bgOverlay.click(function () {
        $('.product-step').removeClass('active')
        bgOverlay.removeClass('active')
        body.removeClass('ohide')
        $($('header').removeClass('hide'))
    })
}

// CONTACT
if ($('.contact-top-field').length) {
    let mapField = $('.map-field')
    mapField.find('.image')

    let mainField = $('.contact-top-field')
    let mainWrapper = mainField.find('.wrapper')
    let contentField = $('.contact-top-field .wrapper .map')
    let remainWidth = (mainField.width() - mainWrapper.width()) / 2
    $.each(contentField, function () {
        contentField.css({
            'left': -remainWidth,
            'right': -remainWidth,
            'width': 'calc(100% + ' + remainWidth * 2 + 'px)'
        })
    })

    $(window).on('resize', function () {
        let remainWidth = (mainField.width() - mainWrapper.width()) / 2

        contentField.css({
            'left': -remainWidth,
            'right': -remainWidth,
            'width': 'calc(100% + ' + remainWidth * 2 + 'px)'
        })
    })
}

// MOBILE MENU
if ($('.other-menu-field').length) {
    let languageSelector = $('.other-menu-field .languages')
    let menuUL = $('.menu-field .menu > ul')
    if (windowWidth <= 768) {
        menuUL.append(languageSelector)
    }
}

// FLATPICKR
import flatpickr from "flatpickr";
import { Turkish } from "flatpickr/dist/l10n/tr.js"

if ($('.dateselect').length) {
    // PERIOD CONTENT HEIGHT
    let calendarContent = $('.calendar-content')
    calendarContent.height(calendarContent.find('.calendar-inner-content .period.active .period-inner').height())
}

// DATE SELECT - FLATPICKR
$(".dateselect").flatpickr({
    'inline': true,
    'locale': Turkish,
    'dateFormat': "d-m-Y",
    'ariaDateFormat': 'j F Y',
    onMonthChange: function (selectedDates, dateStr, instance) {
        let months = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
        let currentMonth = months[instance.currentMonth]
        let currentYear = instance.currentYear
        let calendarContent = $('.calendar-content')
        let currentPeriod = currentMonth + " " + currentYear
        let calendarBox = $('.calendar-box')
        let period = $('.period.fillable')
        let periodNoContent = $('.period.no-content')
        let allPeriods = []
        let calendarBoxData, periodID
        setTimeout(() => {
            $.each(calendarBox, function () {
                calendarBoxData = $(this).attr('data-date')
                $('.flatpickr-day[aria-label="' + calendarBoxData + '"]').addClass('active')
            })
            $.each(period, function () {
                period.removeClass('active')
                periodID = $(this).attr('data-period')
                if (currentPeriod == periodID) {
                    setTimeout(() => {
                        $(this).addClass('active')
                        calendarContent.height($(this).find('.period-inner').height())
                    }, 50);
                }
                allPeriods.push(periodID)
            })
            $.each(allPeriods, function (i) {
                if (currentPeriod == allPeriods[i]) {
                    periodNoContent.removeClass('active')
                    return false;
                } else {
                    periodNoContent.addClass('active')
                }
            })
            let calendarDay = $('.flatpickr-day')
            let calendarDayID, calendarBoxID
            calendarBox.hover(
                function () {
                    calendarDayID = $(this).attr('data-date')
                    $('.flatpickr-day[aria-label="' + calendarDayID + '"]').addClass('select')
                },
                function () {
                    calendarDay.removeClass('select')
                }
            )
            calendarDay.hover(
                function () {
                    calendarBoxID = $(this).attr('aria-label')
                    $('.calendar-box[data-date="' + calendarBoxID + '"]').addClass('select')
                },
                function () {
                    $.each(calendarBox, function () {
                        $(this).removeClass('select')
                    })
                }
            )
        }, 450);
    },
    onChange: function (selectedDates, dateStr, instance) {
        let months = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
        let currentMonth = months[instance.currentMonth]
        let currentYear = instance.currentYear
        let calendarContent = $('.calendar-content')
        let currentPeriod = currentMonth + " " + currentYear
        let calendarBox = $('.calendar-box')
        let period = $('.period')
        let calendarBoxData, periodID
        setTimeout(() => {
            $.each(calendarBox, function () {
                calendarBoxData = $(this).attr('data-date')
                $('.flatpickr-day[aria-label="' + calendarBoxData + '"]').addClass('active')
            })
            $.each(period, function () {
                period.removeClass('active')
                periodID = $(this).attr('data-period')
                if (currentPeriod == periodID) {
                    setTimeout(() => {
                        $(this).addClass('active')
                        calendarContent.height($(this).find('.period-inner').height())
                    }, 50);
                }
            })
            let calendarDay = $('.flatpickr-day')
            let calendarDayID, calendarBoxID
            calendarBox.hover(
                function () {
                    calendarDayID = $(this).attr('data-date')
                    $('.flatpickr-day[aria-label="' + calendarDayID + '"]').addClass('select')
                },
                function () {
                    calendarDay.removeClass('select')
                }
            )
            calendarDay.hover(
                function () {
                    calendarBoxID = $(this).attr('aria-label')
                    $('.calendar-box[data-date="' + calendarBoxID + '"]').addClass('select')
                },
                function () {
                    $.each(calendarBox, function () {
                        $(this).removeClass('select')
                    })
                }
            )
        }, 450);
    },
});

// FLATPICKR FIELD
if ($('.dateselect').length) {
    let daySelector = $('.flatpickr-day')
    let calendarBox = $('.calendar-box')
    let dayData, calendarBoxData
    $.each(calendarBox, function () {
        calendarBoxData = $(this).attr('data-date')
        $('.flatpickr-day[aria-label="' + calendarBoxData + '"]').addClass('active')
    })
}


// CALENDAR BOX - HOVER
if ($('.homepage-calendar-field').length) {
    let calendarDay = $('.flatpickr-day')
    let calendarBox = $('.calendar-box')
    let calendarDayID, calendarBoxID
    calendarBox.hover(
        function () {
            calendarDayID = $(this).attr('data-date')
            $('.flatpickr-day[aria-label="' + calendarDayID + '"]').addClass('select')
        },
        function () {
            calendarDay.removeClass('select')
        }
    )
    calendarDay.click(function () {

    })
    calendarDay.hover(
        function () {
            calendarBoxID = $(this).attr('aria-label')
            $('.calendar-box[data-date="' + calendarBoxID + '"]').addClass('select')
        },
        function () {
            $.each(calendarBox, function () {
                $(this).removeClass('select')
            })
        }
    )
}

// DATA-FANCYBOX MOBILE CANCELED
if ($('[data-fancybox]').length) {
    let fancyBoxCatalog = $('.catalog-text-field .image-field .image > a')
    if (windowWidth < 1025) {
        $.each(fancyBoxCatalog, function () {
            $(this).removeAttr('data-fancybox')
            $(this).attr('download', '')
        })
    }
    $(window).resize(function () {
        let ww = window.innerWidth
        if (ww < 1025) {
            $.each(fancyBoxCatalog, function () {
                $(this).removeAttr('data-fancybox')
                $(this).attr('download', '')
            })
        }
    });
}

if ($('.calendar-box').length) {
    $('.calendar-box').first().addClass('select')
    // HOVER OLUNCA remove class select
    $('.calendar-box').hover(
        function () {
            $('.calendar-box').removeClass('select')
            $(this).addClass('select')
        },
        function () {
            $('.calendar-box').removeClass('select')
            $('.calendar-box').first().addClass('select')
        }
    )
}

//  .homepage-calendar-field .blog-field .carousel-controller ALANINI .homepage-calendar-field .blog-field .title-field İÇERİSİNE APPEND YAP
/* if ($('.homepage-calendar-field .blog-field .carousel-controller').length) {
    if (windowWidth < 1025) {
        $('.homepage-calendar-field .blog-field .carousel-controller').each(function () {
            $(this).appendTo($(this).closest('.blog-field').find('.title-field'))
        })
    }
} */